export default __webpack_public_path__ + "static/media/7.938d0660.png";